<script setup lang="ts">
import CopyBtn from '~/components/buttons/CopyBtn.vue';
import { useProductStore } from '~/store/product/productStore';
import { MODAL_BRAND_VOUCHER, MODAL_OPEN, useModalStore } from '~/store/modalStore';

const productStore = useProductStore();
const {
  getBrandVoucherData
} = storeToRefs(productStore);

const modalStore = useModalStore();
const modal = () => modalStore.displayModal(MODAL_BRAND_VOUCHER, MODAL_OPEN);
</script>

<template>
  <div class="brand-voucher">
    <div class="brand-voucher__wrapper df jcsb">
      <div class="brand-voucher__title c-white df aic">
        <span class="mr-1">
            {{ $t('www.brand-voucher.modal.afford_v2', {'advValue': getBrandVoucherData.advValue, 'code': getBrandVoucherData.code}) }}
        </span>
        <div class="c-white">
          <copy-btn
:code="getBrandVoucherData.code"
                    :message="$t('www.voucher_code.copy.message')"
                    tclz-category="product" />
        </div>
      </div>
      <div class="df size--subheadline c-white">
        <span class="underline-text pointer" @click="modal">
            {{ $t('www.brand-voucher.modal.use.link') }}
        </span>
      </div>
    </div>
  </div>
</template>
